import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/vconsole.js'

// 全局的插件
import MessagePlugin from '@/components/myMessage/MessageComponent'
Vue.use(MessagePlugin)

import "@/styles/index.scss";
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
